export const KEY_OPEN_ID = 'openId';

/**
 * 获取
 */

function getValue (key) {
  return typeof (Storage) !== 'undefined' ? localStorage.getItem(key) : false;
}

/**
 * 保存
 */

function saveValue (key, value) {
  // Check browser support
  if (typeof (Storage) !== 'undefined') {
    // Store
    localStorage.setItem(key, value);
  } else {
    console.log('browser not support localStorage');
  }
}

function removeValue (key) {
  localStorage.removeItem(key);
}

function isEmpty (obj) {
  return !obj || obj === '';
}

//判断是否是微信浏览器的函数
function isWeiXin () {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}

function getCookie (cname) {
  var name = cname + '=';
  var ca = document.cookie.split(';');
  console.log('获取cookie,现在循环');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    console.log(c);
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) != -1) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

/**
 * 将以base64的图片url数据转换为Blob
 * @param urlData
 *            用url方式表示的base64图片数据
 */
function convertBase64UrlToBlob(urlData)
{
  var arr = urlData.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: mime
  });
}

function canvasDataURL(path, obj, callback)
{
  var img = new window.Image();
  img.src = path;
  img.onload = function() {
    var that = this;
    // 默认按比例压缩
    var w = that.width,
      h = that.height,
      scale = w / h;
    w = obj.width || w;
    h = obj.height || (w / scale);
    var quality = 0.7; // 默认图片质量为0.7
    //生成canvas
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    // 创建属性节点
    var anw = document.createAttribute('width');
    anw.nodeValue = w;
    var anh = document.createAttribute('height');
    anh.nodeValue = h;
    canvas.setAttributeNode(anw);
    canvas.setAttributeNode(anh);
    ctx.drawImage(that, 0, 0, w, h);
    // 图像质量
    if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
      quality = obj.quality;
    }
    // quality值越小，所绘制出的图像越模糊
    var base64 = canvas.toDataURL('image/jpeg', quality);

    //将base64转换成图片
    var bl = convertBase64UrlToBlob(base64);

    // var arr = base64.split(','),
    //   mime = arr[0].match(/:(.*?);/)[1],
    //   bstr = atob(arr[1]),
    //   n = bstr.length,
    //   u8arr = new Uint8Array(n);
    // while (n--) {
    //   u8arr[n] = bstr.charCodeAt(n);
    // }
    // var bl = convertBase64UrlToBlob(base64);
    //
    // new Blob([u8arr], {
    //   type: mime
    // });

    // 回调函数返回图片
    callback(bl);

  };
}

/*
    三个参数
    file：一个是文件(类型是图片格式)，
    w：一个是文件压缩的后宽度，宽度越小，字节越小
    objDiv：一个是容器或者回调函数
    photoCompress()
    */
function photoCompress(file, w, objDiv)
{
  var ready = new FileReader();
  /*开始读取指定的Blob对象或File对象中的内容. 当读取操作完成时,readyState属性的值会成为DONE,如果设置了onloadend事件处理程序,则调用之.同时,result属性中将包含一个data: URL格式的字符串以表示所读取文件的内容.*/
  ready.readAsDataURL(file);
  ready.onload = function() {
    var re = this.result;
    canvasDataURL(re, w, objDiv);
  };
}

//旋转图片到正常
// function  rotateImg(imgFile) {
//   return new Promise((resolve, reject) => {
//     window.EXIF.getData(imgFile, function () {
//       let exifTags = window.EXIF.getAllTags(this);

//       alert(exifTags.Orientation);

//       let reader = new FileReader();
//       reader.readAsDataURL(imgFile);
//       reader.onload = e => {
//         let imgData = e.target.result;
//         // 8 表示 顺时针转了90
//         // 3 表示 转了 180
//         // 6 表示 逆时针转了90
//         if (
//           exifTags.Orientation == 8 ||
//           exifTags.Orientation == 3 ||
//           exifTags.Orientation == 6
//         ) {

//           //翻转
//           //获取原始图片大小
//           const img = new Image();
//           img.src = imgData;
//           img.onload = function () {
//             let cvs = document.createElement('canvas');
//             let ctx = cvs.getContext('2d');
//             //如果旋转90
//             if (
//               exifTags.Orientation == 8 ||
//               exifTags.Orientation == 6
//             ) {
//               cvs.width = img.height;
//               cvs.height = img.width;
//             } else {
//               cvs.width = img.width;
//               cvs.height = img.height;
//             }
//             if (exifTags.Orientation == 6) {
//               //原图逆时针转了90, 所以要顺时针旋转90
//               ctx.rotate(Math.PI / 180 * 90);
//               ctx.drawImage(
//                 img,
//                 0,
//                 0,
//                 img.width,
//                 img.height,
//                 0,
//                 -img.height,
//                 img.width,
//                 img.height
//               );

//               alert("原图逆时针转了90, 所以要顺时针旋转90");

//             }
//             if (exifTags.Orientation == 3) {
//               //原图逆时针转了180, 所以顺时针旋转180
//               ctx.rotate(Math.PI / 180 * 180);
//               ctx.drawImage(
//                 img,
//                 0,
//                 0,
//                 img.width,
//                 img.height,
//                 -img.width,
//                 -img.height,
//                 img.width,
//                 img.height
//               );
//               alert("原图逆时针转了180, 所以顺时针旋转180");
//             }
//             if (exifTags.Orientation == 8) {
//               //原图顺时针旋转了90, 所以要你时针旋转90
//               ctx.rotate(Math.PI / 180 * -90);
//               ctx.drawImage(
//                 img,
//                 0,
//                 0,
//                 img.width,
//                 img.height,
//                 -img.width,
//                 0,
//                 img.width,
//                 img.height
//               );
//             }
//             alert("原图顺时针旋转了90, 所以要你时针旋转90");
//             resolve(cvs.toDataURL('image/png'));
//           }
//         }
//         else {
//           resolve(imgData);
//         }
//       }
//     });
//   });
// }


// function selectFileImage(fileObj) {
//   var file = fileObj.files['0'];
//   //图片方向角 added by lzk
//   var Orientation = null;
//
//   if (file) {
//     console.log("正在上传,请稍后...");
//     var rFilter = /^(image\/jpeg|image\/png)$/i; // 检查图片格式
//     if (!rFilter.test(file.type)) {
//       //showMyTips("请选择jpeg、png格式的图片", false);
//       return;
//     }
//     // var URL = URL || webkitURL;
//     //获取照片方向角属性，用户旋转控制
//     EXIF.getData(file, function() {
//       // alert(EXIF.pretty(this));
//       EXIF.getAllTags(this);
//       //alert(EXIF.getTag(this, 'Orientation'));
//       Orientation = EXIF.getTag(this, 'Orientation');
//       //return;
//     });
//
//     var oReader = new FileReader();
//     oReader.onload = function(e) {
//       //var blob = URL.createObjectURL(file);
//       //_compress(blob, file, basePath);
//       var image = new Image();
//       image.src = e.target.result;
//       image.onload = function() {
//         var expectWidth = this.naturalWidth;
//         var expectHeight = this.naturalHeight;
//
//         if (this.naturalWidth > this.naturalHeight && this.naturalWidth > 800) {
//           expectWidth = 800;
//           expectHeight = expectWidth * this.naturalHeight / this.naturalWidth;
//         } else if (this.naturalHeight > this.naturalWidth && this.naturalHeight > 1200) {
//           expectHeight = 1200;
//           expectWidth = expectHeight * this.naturalWidth / this.naturalHeight;
//         }
//         var canvas = document.createElement("canvas");
//         var ctx = canvas.getContext("2d");
//         canvas.width = expectWidth;
//         canvas.height = expectHeight;
//         ctx.drawImage(this, 0, 0, expectWidth, expectHeight);
//         var base64 = null;
//         //修复ios
//         if (navigator.userAgent.match(/iphone/i)) {
//           console.log('iphone');
//           //alert(expectWidth + ',' + expectHeight);
//           //如果方向角不为1，都需要进行旋转 added by lzk
//           if(Orientation != "" && Orientation != 1){
//             alert('旋转处理');
//             switch(Orientation){
//               case 6://需要顺时针（向左）90度旋转
//                 alert('需要顺时针（向左）90度旋转');
//                 rotateImg(this,'left',canvas);
//                 break;
//               case 8://需要逆时针（向右）90度旋转
//                 alert('需要顺时针（向右）90度旋转');
//                 rotateImg(this,'right',canvas);
//                 break;
//               case 3://需要180度旋转
//                 alert('需要180度旋转');
//                 rotateImg(this,'right',canvas);//转两次
//                 rotateImg(this,'right',canvas);
//                 break;
//             }
//           }
//
//           /*var mpImg = new MegaPixImage(image);
//           mpImg.render(canvas, {
//             maxWidth: 800,
//             maxHeight: 1200,
//             quality: 0.8,
//             orientation: 8
//           });*/
//           base64 = canvas.toDataURL("image/jpeg", 0.8);
//         }else if (navigator.userAgent.match(/Android/i)) {// 修复android
//           var encoder = new JPEGEncoder();
//           base64 = encoder.encode(ctx.getImageData(0, 0, expectWidth, expectHeight), 80);
//         }else{
//           //alert(Orientation);
//           if(Orientation != "" && Orientation != 1){
//             //alert('旋转处理');
//             switch(Orientation){
//               case 6://需要顺时针（向左）90度旋转
//                 alert('需要顺时针（向左）90度旋转');
//                 rotateImg(this,'left',canvas);
//                 break;
//               case 8://需要逆时针（向右）90度旋转
//                 alert('需要顺时针（向右）90度旋转');
//                 rotateImg(this,'right',canvas);
//                 break;
//               case 3://需要180度旋转
//                 alert('需要180度旋转');
//                 rotateImg(this,'right',canvas);//转两次
//                 rotateImg(this,'right',canvas);
//                 break;
//             }
//           }
//
//           base64 = canvas.toDataURL("image/jpeg", 0.8);
//         }
//         //uploadImage(base64);
//         //$("#myImage").attr("src", base64);
//       };
//     };
//     oReader.readAsDataURL(file);
//   }
// }
//
// //对图片旋转处理 added by lzk
// function rotateImg(img, direction,canvas) {
//   //alert(img);
//   //最小与最大旋转方向，图片旋转4次后回到原方向
//   var min_step = 0;
//   var max_step = 3;
//   //var img = document.getElementById(pid);
//   if (img == null)return;
//   //img的高度和宽度不能在img元素隐藏后获取，否则会出错
//   var height = img.height;
//   var width = img.width;
//   //var step = img.getAttribute('step');
//   var step = 2;
//   if (step == null) {
//     step = min_step;
//   }
//   if (direction == 'right') {
//     step++;
//     //旋转到原位置，即超过最大值
//     step > max_step && (step = min_step);
//   } else {
//     step--;
//     step < min_step && (step = max_step);
//   }
//   //img.setAttribute('step', step);
//   /*var canvas = document.getElementById('pic_' + pid);
//   if (canvas == null) {
//       img.style.display = 'none';
//       canvas = document.createElement('canvas');
//       canvas.setAttribute('id', 'pic_' + pid);
//       img.parentNode.appendChild(canvas);
//   }  */
//   //旋转角度以弧度值为参数
//   var degree = step * 90 * Math.PI / 180;
//   var ctx = canvas.getContext('2d');
//   switch (step) {
//     case 0:
//       canvas.width = width;
//       canvas.height = height;
//       ctx.drawImage(img, 0, 0);
//       break;
//     case 1:
//       canvas.width = height;
//       canvas.height = width;
//       ctx.rotate(degree);
//       ctx.drawImage(img, 0, -height);
//       break;
//     case 2:
//       canvas.width = width;
//       canvas.height = height;
//       ctx.rotate(degree);
//       ctx.drawImage(img, -width, -height);
//       break;
//     case 3:
//       canvas.width = height;
//       canvas.height = width;
//       ctx.rotate(degree);
//       ctx.drawImage(img, -width, 0);
//       break;
//   }
// }


/**
 * 处理 input 重复点击多次，弹出多次文件选择的问题
 */
function  ReInput({target, ok, params, type}){
  let param = [].slice.call(params)
    .filter((_, i) => i != 0)
  let parentNode = target.parentNode
  let dataVal = Object.keys(target.dataset)[0]
  let input = document.createElement('input')
  input.type = type || 'file'
  input.onchange = e => ok.apply(null, [e, ...param])
  input.dataset[dataVal] = ""
  input.setAttribute('class', target.getAttribute('class'))
  parentNode.removeChild(target)
  parentNode.appendChild(input)
}

export { getValue, saveValue, removeValue, isEmpty, isWeiXin, getCookie , photoCompress, convertBase64UrlToBlob, ReInput};

